/**
 * このアプリの画面サイズが更新された際、iframeの外に現在の画面サイズを伝える責務を担う
 * これによりtheme側スクリプトでiframeの高さが動的に追従するなる処理が発生する
 */
import { useEffect, MutableRefObject } from 'react';

export const useEmitResetWindow = (
  rootElementReference: MutableRefObject<HTMLDivElement | null>,
  dependencies: any[]
) => {

  const postDocumentHeightToParent = (height: number) => {
    window.parent.postMessage({ action: 'resetWindow', height }, '*');
  };

  // 画面リサイズの際の処理
  useEffect(() => {
    const handleResizeWindow = () => {

      const documentBody = document.querySelector('body');

      if(!documentBody!.scrollHeight) return;

      const documentHeight = documentBody!.scrollHeight;

      postDocumentHeightToParent(documentHeight);
    };

    window.addEventListener('resize', handleResizeWindow);

    return () => window.removeEventListener('resize', handleResizeWindow);
  }, []);

  // 要素変動による画面領域変動の際の処理
  useEffect(() => {
    const documentHeight = rootElementReference.current?.clientHeight ?? 0;
    postDocumentHeightToParent(documentHeight);
  }, [...dependencies, rootElementReference.current?.clientHeight]);
};
